import { useState, forwardRef } from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import HelpIcon from '@mui/icons-material/Help';
import './RegisterForm.css';
import { Button,Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@material-ui/core';
import axios from 'axios';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useHistory } from 'react-router';
import Navbar from "../../Components/Navbar/Navbar";
const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
function FormSignup() {
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [error, setErrorMessage] = useState('');
  const [success, setSuccessMessage] = useState('');

  const handleClose = () => {
    setOpenError(false);
    setOpenSuccess(false);
  };
  const formik = useFormik({
    initialValues: {
      Names: '',
      Username: '',
      Email: '',
      Password: '',
      VerifyPassword: '',
      Code: ''
    },
    validationSchema: yup.object({
      Names: yup.string()
        .required('Campo requerido *'),
      Username: yup.string()
        .min(3, 'Usuario muy corto')
        .max(20, 'Usuario demasiado largo')
        .required('Campo requerido *'),
      Email: yup.string()
        .email('Correo inválido')
        .required('Campo requerido *'),
      Password: yup.string()
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
          "Debe tener mínimo 8 carácteres, una mayúscula, una minúscula, un número y un carácter especial"
        ).required('Campo requerido *'),

      VerifyPassword: yup.string()
        .required('Campo requerido *')
        .oneOf([yup.ref('Password'), null], 'Contraseñas no coinciden'),
      Code: yup.string().required('Código requerido *')
    }),
  
    onSubmit: values => {
      axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/users/register`, {
        name: values.Names,
        username: values.Username,
        email: values.Email,
        password: values.Password,
        code: values.Code
      }).then((response) => {
        if (response.data.messageError) {
          setErrorMessage(response.data.messageError);
          setOpenError(true);
        }
        else if (response.data.messageSuccess) {
          setSuccessMessage(response.data.messageSuccess);
          setOpenSuccess(true);
          formik.resetForm();
          changeCode();

        }
        else {
          setErrorMessage('');
          setSuccessMessage('');
          setOpenError(false);
          setOpenSuccess(false);
        }
      });
    }
  });
  const changeCode = () => {
    axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/users/changeCode`)
  }
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  return (
    <>
      <Navbar />
      <div className="register" >
        <div className='form-container-register'>
          <div className='form-content-left-register'>
            <img className='form-img-register' src='hacker2.svg' alt='hacker' />
       
          </div>
          <div className='form-content-right-register'>
            <form
              className='form-register'
              onSubmit={formik.handleSubmit}
            >
              <h1 className="h1Register">
                ¡Empieza tu camino en ciberseguridad ahora! 
              </h1>
              <div className='form-inputs-register'>
                <div className='form-label-form'>
                  <label className='form-label-register'>Nombres Completos</label>
                  {formik.touched.Names && formik.errors.Names ? <span className="spanRed">{formik.errors.Names}</span> : null}
                </div>
                <input
                  className='form-input-register'
                  type='text'
                  name='Names'
                  placeholder='Ingresa tus nombres completos'
                  {...formik.getFieldProps("Names")}
                />
              </div>
              <div className='form-inputs-register'>
                <div className='form-label-form'>
                  <label className='form-label-register'>Usuario</label>
                  {formik.touched.Username && formik.errors.Username ? <span className="spanRed">{formik.errors.Username}</span> : null}
                </div>
                <input
                  className='form-input-register'
                  type='text'
                  name='Username'
                  placeholder='Ingresa tu usuario'
                  {...formik.getFieldProps("Username")}
                />
              </div>
              <div className='form-inputs-register'>
                <div className='form-label-form'>
                  <label className='form-label-register'>Email</label>
                  {formik.touched.Email && formik.errors.Email ? <span className="spanRed">{formik.errors.Email}</span> : null}
                </div>
                <input
                  className='form-input-register'
                  type='email'
                  name='Email'
                  placeholder='Ingresa tu correo'
                  {...formik.getFieldProps("Email")}
                />
              </div>
              <div className='form-inputs-register'>
                <div className='form-label-form'>
                  <label className='form-label-register'>Contraseña</label>
                  {formik.touched.Password && formik.errors.Password ? <span className="spanRed">{formik.errors.Password}</span> : null}
                </div>
                <input
                  className='form-input-register'
                  type='password'
                  name='Password'
                  placeholder='Ingresa tu contraseña'
                  {...formik.getFieldProps("Password")}
                />
              </div>
              <div className='form-inputs-register'>
                <div className='form-label-form'>
                  <label className='form-label-register'>Confirmar Contraseña</label>
                  {formik.touched.VerifyPassword && formik.errors.VerifyPassword ? <span className="spanRed">{formik.errors.VerifyPassword}</span> : null}
                </div>
                <input
                  className='form-input-register'
                  type='password'
                  name='VerifyPassword'
                  placeholder='Confirma tu contraseña'
                  {...formik.getFieldProps("VerifyPassword")}
                />
                 <div className='form-inputs-register'>
                  <label className='form-label-register'>Código de registro</label>
                {formik.touched.Code && formik.errors.Code ? <span className="spanRed">{formik.errors.Code}</span> : null}              
                </div>
                <div className="divStyling">
                <input
                  className='form-input-register'
                  type='text'
                  name='Code'
                  placeholder='El código lo dejó un desarrollador como mala práctica'
                  
                  {...formik.getFieldProps("Code")}
                />
                <HelpIcon className="cursorPointer iconStyle" onClick={()=>{setOpenDialog(true)}}/>
                </div>
              </div>
              <button className='form-input-btn-register' type='submit' >
                Regístrate
              </button>
             
            </form>
          </div>
        </div>
        <Snackbar open={openError} autoHideDuration={3000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" className="alertStyling">
            {error}
          </Alert>
        </Snackbar>
        <Snackbar open={openSuccess} autoHideDuration={3000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="success" className="alertStyling">
            {success}
          </Alert>
        </Snackbar>
        <Dialog
            open={openDialog}
            onClose={handleCloseDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"Instrucciones para resolver el reto"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                1.Busca en la sección de nosotros al desarrollador.
              </DialogContentText>
              <DialogContentText id="alert-dialog-description">
                2.Dale clic derecho e inspeccionar elemento.
              </DialogContentText>
              <DialogContentText id="alert-dialog-description">
                3.Encuentra la pista y el código oculto.
              </DialogContentText>
              <DialogContentText id="alert-dialog-description">
                Nota: El código cambia cada vez que un usuario se registra exitosamente.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDialog} autoFocus>
                Cerrar
              </Button>
            </DialogActions>
          </Dialog>
      </div >
    </>
  );
};

export default FormSignup;
